export default __webpack_public_path__ + "static/media/resume-zoom.a7854f1f.svg";